import React from 'react';
import { Col, Row, Table } from 'react-bootstrap';
import illus38 from 'assets/img/spot-illustrations/38.png';
import illusDark38 from 'assets/img/spot-illustrations/dark_38.png';
import { useWizardFormContext } from 'providers/WizardFormProvider';
import { WizardFormData } from 'components/forms/CampaignWizardForm';

const WizardSuccessStep = () => {
  const { formData } = useWizardFormContext<WizardFormData>();

  // eslint-disable-next-line
  const renderAssociations = (associations: any[], title: string) => (
    <>
      <h6 className="mt-3">{title}</h6>
      <Table striped bordered size="sm" className="fs-9">
        <thead>
          <tr>
            {Object.keys(associations[0] || {}).map(key => (
              <th key={key} className="px-2">
                {key}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {associations.map((item, index) => (
            <tr key={index}>
              {
                // eslint-disable-next-line
                Object.values(item).map((value: any, i) => (
                  <td key={i} className="px-2">
                    {typeof value === 'boolean' ? value.toString() : value}
                  </td>
                ))
              }
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );

  return (
    <Row className="flex-center pb-0 pt-2 gx-3 gy-4">
      <Col xs={6} sm="auto" className="text-center text-sm-start">
        <img src={illus38} alt="" width={110} className="d-dark-none" />
        <img src={illusDark38} alt="" width={110} className="d-light-none" />
      </Col>
      <Col xs={6} sm="auto" className="text-center text-sm-start">
        <h5 className="mb-3">You are all set!</h5>
        <p className="text-body-emphasis fs--1">
          Now you can update/create the Campaign
          <br />
          by clicking on the button.
        </p>
      </Col>
      <div
        className="p-3 pt-0 pb-3 border rounded scrollbar"
        style={{ height: '250px', overflowY: 'auto' }}
      >
        <Col xs={12} className="mt-2">
          <h6>Campaign Configuration Summary</h6>
          <Table striped bordered size="sm" className="fs-9">
            <tbody>
              {Object.entries(formData).map(([key, value]) => {
                if (typeof value !== 'object') {
                  return (
                    <tr key={key}>
                      <td className="px-2">
                        <strong>{key}</strong>
                      </td>
                      <td className="px-2">
                        {typeof value === 'boolean' ? value.toString() : value}
                      </td>
                    </tr>
                  );
                } else if (
                  key === 'timeschedule' ||
                  key === 'mediagroup' ||
                  key === 'greeting'
                ) {
                  return (
                    <tr key={key}>
                      <td className="px-2">
                        <strong>{key}</strong>
                      </td>
                      <td className="px-2">
                        ID: {value.id}, Name: {value.shortname}
                      </td>
                    </tr>
                  );
                }
                return null;
              })}
            </tbody>
          </Table>

          {formData.outboundRuleAssociations &&
            formData.outboundRuleAssociations.length > 0 &&
            renderAssociations(
              formData.outboundRuleAssociations,
              'Outbound Rule Associations'
            )}

          {formData.callingListAssociations &&
            formData.callingListAssociations.length > 0 &&
            renderAssociations(
              formData.callingListAssociations,
              'Calling List Associations'
            )}
        </Col>
      </div>
    </Row>
  );
};

export default WizardSuccessStep;
